<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'empty') {
    <empty-layout></empty-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Main logged in layout with vertical side navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'logged-in-main') {
    <logged-in-main></logged-in-main>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Logged in layout for single page without vertical side navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'logged-in-single') {
    <logged-in-single></logged-in-single>
}
